import * as React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ImageVersion } from '../../imagePreview/queries/use-query-edited-image';
import { useAddCommentMutation } from '../queries/use-mutation-add-comment';
import { canViewComments } from '../state/utils';
import { ImageCommentForm } from './ImageCommentForm';
import { ImageCommentList } from './ImageCommentList';

const Section = styled('section')({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    overflowY: 'auto',
    paddingRight: '4px'
});

type ImageCommentsSectionProps = {
    orderId: number;
    user: AuthenticatedUser;
    version: ImageVersion;
    isLatestVersion: boolean;
};

export function ImageCommentsSection({
    orderId,
    user,
    version,
    isLatestVersion
}: ImageCommentsSectionProps) {
    let addComment = useAddCommentMutation({ orderId, imageId: version.id, user });

    if (!canViewComments(user)) {
        return null;
    }

    let comments = version.commentModel ? version.commentModel.comments : [];

    return (
        <Section aria-labelledby="image-comments-heading">
            <Typography id="image-comments-heading" variant="h3" sx={{ fontSize: '22px', fontWeight: 400 }}>
                {Translate('image-processing/modal/comments/header-label/comments')}
            </Typography>
            <ImageCommentList comments={comments} />
            {isLatestVersion && (
                <ImageCommentForm
                    key={version.id}
                    isSaving={addComment.isLoading}
                    onSave={(text) => addComment.mutateAsync(text)}
                />
            )}
        </Section>
    );
}
